import { cx } from "@emotion/css";

export function CreatorContainer({ className, children }) {
	return <div className={cx(className, "creator-container")}>{children}</div>;
}
